// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"48d5f8ae","46":"841ba2e2","79":"eeff39e1","238":"b1c563ee","453":"1826ebbf","637":"9eebbec9","655":"3ef5e8c6","727":"31a375a2","809":"77c32500","853":"f3cf9a5d"}[chunkId] + ".chunk.js";
};